var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pa-5"},[_c('h1',[_vm._v(_vm._s(_vm.$t("title"))+" "),_c('v-icon',{attrs:{"x-large":""}},[_vm._v("far fa-frown")])],1),_c('p',{staticClass:"pt-4"},[_vm._v(_vm._s(_vm.$t("note")))])])}
var staticRenderFns = []

export { render, staticRenderFns }